import { isArray } from 'lodash';

const ensureIsArray = <T>(val: T | T[]): T[] => (isArray(val) ? val : [val]);

export default ensureIsArray;
